import React from 'react';
import {classNames} from "../../../utils/common";

const CommentField = ({comment, setComment, withLabel = true, smallerSize = false, ...props}) => {
    return (
        <div {...props}>
            {withLabel && <label htmlFor="comment" className={classNames(
                smallerSize ? "ml-1 text-xs" : "ml-3 text-sm",
                "block font-medium text-gray-700"
            )}>Comment</label>}
            <div className={classNames(
                smallerSize ? "mt-0.5 h-7" : "mt-1 h-10",
                "relative rounded-md shadow-sm"
            )}>
                <input value={comment} onChange={(event) => setComment(event.target.value)} type="text" id="comment"
                       className={classNames(
                           smallerSize
                               ? "h-7 w-36 px-1.5 text-xs"
                               : "h-10 w-60 px-3 sm:text-sm",
                           "focus:ring-indigo-500 focus:border-indigo-500 block border-gray-300 rounded-md"
                       )}/>
            </div>
        </div>
    );
};

export default CommentField;
